<template>
  <tr>
    <td class="py-2 px-1">
      <DatePicker
        v-model="startFrom"
        label="Дата дії грейду з"
        :filled="false"
      />
    </td>

    <td class="py-2 px-1">
      <ProjectSelect v-model="project" />
    </td>

    <td class="py-2 px-1">
      <DecimalEditor
        v-model="grade"
        label="Грейд"
        required
        :scale="2"
        :error-messages="$v.grade.$error ? gradeErrors : []"
        hide-details="auto"
        @input="$v.grade.$touch()"
      />
    </td>

    <td class="pr-0 py-3">
      <v-btn
        icon
        class="mx-0"
        @click="apply"
      >
        <v-icon color="green lighten-2">
          check
        </v-icon>
      </v-btn>

      <v-btn
        icon
        class="mx-0"
        @click="$emit('cancel', isNew)"
      >
        <v-icon color="red lighten-2">
          close
        </v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import DecimalEditor from "../../../components/DecimalEditor";
import ProjectSelect from "../projects/ProjectSelect";
import DatePicker from "@/components/story/DatePicker";

export default {
  components: {
    DecimalEditor,
    ProjectSelect,
    DatePicker,
  },
  props: ["gradeItem"],
  data: () => ({
    startFrom: null,
    project: null,
    grade: null,
    isNew: false,
  }),
  computed: {
    errors() {
      return {
        REQUIRED: ["Значення грейда обов'язкове та має бути більше '0'"],
      };
    },
    gradeErrors() {
      if (!this.grade || this.grade > 0) {
        return this.errors.REQUIRED;
      }
    },
  },
  watch: {
    gradeItem: {
      handler(item) {
        if (!item) {
          return;
        }
        this.startFrom = item.startFrom;
        this.project = item.project;
        this.grade = item.value;
        this.isNew = item.isNew;
      },
      immediate: true,
    },
  },
  validations: {
    grade: {
      required(value) {
        return value > 0;
      },
    },
  },
  methods: {
    apply() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      this.$emit("apply", {
        startFrom: this.startFrom,
        project: this.project,
        value: this.grade,
        isNew: this.isNew,
      });
    },
  },
};
</script>
